import { AxiosError } from 'axios';

type CalCertMissingResponse = {
  code?: string;
  message?: string;
  controllers?: {
    id: string;
    name: string;
  }[];
};

export type CalCertMissingError = {
  message: string;
  controllers: NonNullable<CalCertMissingResponse['controllers']>;
};

export const getMissingCalcertError = (error: unknown): CalCertMissingError | null => {
  if (!(error instanceof AxiosError)) {
    return null;
  }

  if (error.response?.status !== 409) {
    return null;
  }

  const data = error.response.data as CalCertMissingResponse;

  if (data?.code !== 'CONTROLLERS_MISSING_VALID_CALCERT') {
    return null;
  }

  return {
    message: data.message || 'One or more controllers do not have a valid calibration certificate.',
    controllers: data.controllers || [],
  };
};
